import React, { useMemo, useRef, useState } from "react";
import JoditEditor from "jodit-react";
import "./career-form-page.css"; // styles below

const API = "https://api.ainfotech.com.np";

export default function CareerForm({ initial, onSaved, onCancel }) {
  const editor = useRef(null);

  const [title, setTitle] = useState(initial?.title || "");
  const [employmentType, setEmploymentType] = useState(initial?.employment_type || "full-time");
  const [level, setLevel] = useState(initial?.level || "junior");
  const [category, setCategory] = useState(initial?.category || "Engineering");
  const [location, setLocation] = useState(initial?.location || "");
  const [status, setStatus] = useState(initial?.status || "open");
  const [postedAt, setPostedAt] = useState(initial?.posted_at?.slice?.(0,10) || "");
  const [deadlineAt, setDeadlineAt] = useState(initial?.deadline_at?.slice?.(0,10) || "");
  const [excerpt, setExcerpt] = useState(initial?.excerpt || "");
  const [content, setContent] = useState(initial?.content_html || "");
  const [cover, setCover] = useState(null);
  const [saving, setSaving] = useState(false);

  const config = useMemo(() => ({
    readonly: false,
    height: 360,
    uploader: { insertImageAsBase64URI: true }
  }), []);

  const submit = async (e) => {
    e.preventDefault();
    const fd = new FormData();
    fd.append("title", title);
    fd.append("employment_type", employmentType);
    fd.append("level", level);
    fd.append("category", category);
    if (location) fd.append("location", location);
    fd.append("status", status);
    if (postedAt) fd.append("posted_at", postedAt);
    if (deadlineAt) fd.append("deadline_at", deadlineAt);
    if (excerpt) fd.append("excerpt", excerpt);
    fd.append("content_html", content);
    if (cover) fd.append("cover_image", cover);

    try {
      setSaving(true);
      const url = initial?.id ? `${API}/api/careers/${initial.id}` : `${API}/api/careers`;
      const method = initial?.id ? "PUT" : "POST";
      const res = await fetch(url, { method, credentials: "include", body: fd });
      const data = await res.json();
      if (!res.ok) throw new Error(data?.error || "Save failed");
      onSaved?.();
    } catch (err) {
      alert(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={submit} className="career-form-page minimalist">
      {/* LEFT: content */}
      <section className="cf-left">
        <div className="card">
          <label className="f">
            <span className="f__label">Job Title</span>
            <input className="f__input" value={title} onChange={(e)=>setTitle(e.target.value)} required placeholder="Enter job title" />
          </label>
        </div>

        <div className="card">
          <label className="f">
            <span className="f__label">Card Description (Excerpt)</span>
            <textarea className="f__textarea" rows="3" value={excerpt} onChange={(e)=>setExcerpt(e.target.value)} placeholder="Short summary shown in cards…" />
          </label>
        </div>

        <div className="card">
          <div className="card__title">Cover Image</div>
          <input className="f__input" type="file" accept="image/*" onChange={(e)=>setCover(e.target.files?.[0]||null)} />
        </div>

        <div className="card">
          <div className="card__title">Job Description</div>
          <div className="editor">
            <JoditEditor ref={editor} value={content} config={config} onChange={(val)=>setContent(val)} />
          </div>
        </div>
      </section>

      {/* RIGHT: meta/publish */}
      <aside className="cf-right">
        <div className="card slim">
          <div className="card__title">Publish</div>

          <label className="f">
            <span className="f__label">Status</span>
            <select className="f__input" value={status} onChange={(e)=>setStatus(e.target.value)}>
              <option value="open">open</option>
              <option value="closed">closed</option>
              <option value="draft">draft</option>
            </select>
          </label>

          <label className="f">
            <span className="f__label">Posted Date</span>
            <input className="f__input" type="date" value={postedAt} onChange={(e)=>setPostedAt(e.target.value)} />
          </label>

          <label className="f">
            <span className="f__label">Deadline</span>
            <input className="f__input" type="date" value={deadlineAt} onChange={(e)=>setDeadlineAt(e.target.value)} />
          </label>

          <div className="card__title" style={{ marginTop: 8 }}>Attributes</div>

          <label className="f">
            <span className="f__label">Employment Type</span>
            <select className="f__input" value={employmentType} onChange={(e)=>setEmploymentType(e.target.value)}>
              <option value="full-time">full-time</option>
              <option value="part-time">part-time</option>
              <option value="contract">contract</option>
              <option value="internship">internship</option>
              <option value="temporary">temporary</option>
              <option value="other">other</option>
            </select>
          </label>

          <label className="f">
            <span className="f__label">Level</span>
            <select className="f__input" value={level} onChange={(e)=>setLevel(e.target.value)}>
              <option value="junior">junior</option>
              <option value="mid">mid</option>
              <option value="senior">senior</option>
              <option value="lead">lead</option>
              <option value="manager">manager</option>
            </select>
          </label>

          <label className="f">
            <span className="f__label">Category</span>
            <input className="f__input" value={category} onChange={(e)=>setCategory(e.target.value)} placeholder="e.g., Engineering" />
          </label>

          <label className="f">
            <span className="f__label">Location (optional)</span>
            <input className="f__input" value={location} onChange={(e)=>setLocation(e.target.value)} placeholder="e.g., Kathmandu" />
          </label>

          <div className="row end gap">
            <button type="button" className="btn btn--sm" onClick={onCancel}>Cancel</button>
            <button className="btn primary" disabled={saving}>{saving ? "Saving..." : (initial?.id ? "Update" : "Create")}</button>
          </div>
        </div>
      </aside>
    </form>
  );
}
